 
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../__generated__/schema.types';

import { CmTeasable_CmArticleImpl_Fragment, CmTeasable_CmAudioImpl_Fragment, CmTeasable_CmChannelImpl_Fragment, CmTeasable_CmCollectionImpl_Fragment, CmTeasable_CmDownloadImpl_Fragment, CmTeasable_CmDynamicListImpl_Fragment, CmTeasable_CmExternalLinkImpl_Fragment, CmTeasable_CmGalleryImpl_Fragment, CmTeasable_CmhtmlImpl_Fragment, CmTeasable_CmImageMapImpl_Fragment, CmTeasable_CmInteractiveImpl_Fragment, CmTeasable_CmLocTaxonomyImpl_Fragment, CmTeasable_CmMediaImpl_Fragment, CmTeasable_CmNavigationImpl_Fragment, CmTeasable_CmPersonImpl_Fragment, CmTeasable_CmPictureImpl_Fragment, CmTeasable_CmPlaceholderImpl_Fragment, CmTeasable_CmProductImpl_Fragment, CmTeasable_CmQueryListImpl_Fragment, CmTeasable_CmSelectionRulesImpl_Fragment, CmTeasable_CmSpinnerImpl_Fragment, CmTeasable_CmTaxonomyImpl_Fragment, CmTeasable_CmTeasableImpl_Fragment, CmTeasable_CmTeaserImpl_Fragment, CmTeasable_CmVideoImpl_Fragment, CmTeasable_CmVisualImpl_Fragment, CmTeasable_FormEditorImpl_Fragment, CmTeasable_SosAmountIncreaseFormImpl_Fragment, CmTeasable_SosAuthorImpl_Fragment, CmTeasable_SosChartImpl_Fragment, CmTeasable_SosContactImpl_Fragment, CmTeasable_SosDonationCardImpl_Fragment, CmTeasable_SosDonationCertificateImpl_Fragment, CmTeasable_SosDonationFormImpl_Fragment, CmTeasable_SosDonationProductImpl_Fragment, CmTeasable_SosDonationProgressImpl_Fragment, CmTeasable_SosDonationToolImpl_Fragment, CmTeasable_SosEventImpl_Fragment, CmTeasable_SosFilterTeaserImpl_Fragment, CmTeasable_SosInternalLinkImpl_Fragment, CmTeasable_SosJobTeaserImpl_Fragment, CmTeasable_SosLocationImpl_Fragment, CmTeasable_SosNewsImpl_Fragment, CmTeasable_SosNotificationImpl_Fragment, CmTeasable_SosOfferImpl_Fragment, CmTeasable_SosOrderFormImpl_Fragment, CmTeasable_SosOrganisationImpl_Fragment, CmTeasable_SosOverlayImpl_Fragment, CmTeasable_SosPressreleaseImpl_Fragment, CmTeasable_SosPublicationImpl_Fragment, CmTeasable_SosRedirectPageImpl_Fragment, CmTeasable_SosSpecialTopicCategoryImpl_Fragment, CmTeasable_SosSpecialTopicImpl_Fragment, CmTeasable_SosTeaserImpl_Fragment, CmTeasable_SosTextfragmentImpl_Fragment, CmTeasable_SosTooltipImpl_Fragment, CmTeasable_SosWimmelbildImpl_Fragment, CmTeasable_ViewTypeHeroCollection_Fragment } from '../fragments/__generated__/CMTeasable.fragment';
import { gql } from '@apollo/client';
import { CmTeasableFragmentDoc } from '../fragments/__generated__/CMTeasable.fragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSearchHitListQueryVariables = Types.Exact<{
  search: Types.Scalars['String'];
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  siteId?: Types.InputMaybe<Types.Scalars['String']>;
  docTypes?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type GetSearchHitListQuery = { __typename?: 'Query', content?: { __typename?: 'ContentRoot', search?: { __typename?: 'SearchResult', numFound: number, result?: Array<(
        { __typename?: 'CMArticleImpl', id: string, type: string }
        & CmTeasable_CmArticleImpl_Fragment
      ) | (
        { __typename?: 'CMAudioImpl', id: string, type: string }
        & CmTeasable_CmAudioImpl_Fragment
      ) | (
        { __typename?: 'CMChannelImpl', id: string, type: string }
        & CmTeasable_CmChannelImpl_Fragment
      ) | (
        { __typename?: 'CMCollectionImpl', id: string, type: string }
        & CmTeasable_CmCollectionImpl_Fragment
      ) | (
        { __typename?: 'CMDownloadImpl', id: string, type: string }
        & CmTeasable_CmDownloadImpl_Fragment
      ) | (
        { __typename?: 'CMDynamicListImpl', id: string, type: string }
        & CmTeasable_CmDynamicListImpl_Fragment
      ) | (
        { __typename?: 'CMExternalLinkImpl', id: string, type: string }
        & CmTeasable_CmExternalLinkImpl_Fragment
      ) | (
        { __typename?: 'CMGalleryImpl', id: string, type: string }
        & CmTeasable_CmGalleryImpl_Fragment
      ) | (
        { __typename?: 'CMHTMLImpl', id: string, type: string }
        & CmTeasable_CmhtmlImpl_Fragment
      ) | { __typename?: 'CMImageImpl', id: string, type: string } | (
        { __typename?: 'CMImageMapImpl', id: string, type: string }
        & CmTeasable_CmImageMapImpl_Fragment
      ) | (
        { __typename?: 'CMInteractiveImpl', id: string, type: string }
        & CmTeasable_CmInteractiveImpl_Fragment
      ) | { __typename?: 'CMLinkableImpl', id: string, type: string } | (
        { __typename?: 'CMLocTaxonomyImpl', id: string, type: string }
        & CmTeasable_CmLocTaxonomyImpl_Fragment
      ) | { __typename?: 'CMLocalizedImpl', id: string, type: string } | { __typename?: 'CMMailImpl', id: string, type: string } | (
        { __typename?: 'CMMediaImpl', id: string, type: string }
        & CmTeasable_CmMediaImpl_Fragment
      ) | (
        { __typename?: 'CMNavigationImpl', id: string, type: string }
        & CmTeasable_CmNavigationImpl_Fragment
      ) | { __typename?: 'CMObjectImpl', id: string, type: string } | (
        { __typename?: 'CMPersonImpl', id: string, type: string }
        & CmTeasable_CmPersonImpl_Fragment
      ) | (
        { __typename?: 'CMPictureImpl', id: string, type: string }
        & CmTeasable_CmPictureImpl_Fragment
      ) | (
        { __typename?: 'CMPlaceholderImpl', id: string, type: string }
        & CmTeasable_CmPlaceholderImpl_Fragment
      ) | (
        { __typename?: 'CMProductImpl', id: string, type: string }
        & CmTeasable_CmProductImpl_Fragment
      ) | (
        { __typename?: 'CMQueryListImpl', id: string, type: string }
        & CmTeasable_CmQueryListImpl_Fragment
      ) | { __typename?: 'CMResourceBundleImpl', id: string, type: string } | (
        { __typename?: 'CMSelectionRulesImpl', id: string, type: string }
        & CmTeasable_CmSelectionRulesImpl_Fragment
      ) | { __typename?: 'CMSettingsImpl', id: string, type: string } | { __typename?: 'CMSiteImpl', id: string, type: string } | (
        { __typename?: 'CMSpinnerImpl', id: string, type: string }
        & CmTeasable_CmSpinnerImpl_Fragment
      ) | (
        { __typename?: 'CMTaxonomyImpl', id: string, type: string }
        & CmTeasable_CmTaxonomyImpl_Fragment
      ) | (
        { __typename?: 'CMTeasableImpl', id: string, type: string }
        & CmTeasable_CmTeasableImpl_Fragment
      ) | (
        { __typename?: 'CMTeaserImpl', id: string, type: string }
        & CmTeasable_CmTeaserImpl_Fragment
      ) | (
        { __typename?: 'CMVideoImpl', id: string, type: string }
        & CmTeasable_CmVideoImpl_Fragment
      ) | (
        { __typename?: 'CMVisualImpl', id: string, type: string }
        & CmTeasable_CmVisualImpl_Fragment
      ) | { __typename?: 'Content_Impl', id: string, type: string } | (
        { __typename?: 'FormEditorImpl', id: string, type: string }
        & CmTeasable_FormEditorImpl_Fragment
      ) | (
        { __typename?: 'SOSAmountIncreaseFormImpl', id: string, type: string }
        & CmTeasable_SosAmountIncreaseFormImpl_Fragment
      ) | (
        { __typename?: 'SOSAuthorImpl', id: string, type: string }
        & CmTeasable_SosAuthorImpl_Fragment
      ) | (
        { __typename?: 'SOSChartImpl', id: string, type: string }
        & CmTeasable_SosChartImpl_Fragment
      ) | (
        { __typename?: 'SOSContactImpl', id: string, type: string }
        & CmTeasable_SosContactImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationCardImpl', id: string, type: string }
        & CmTeasable_SosDonationCardImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationCertificateImpl', id: string, type: string }
        & CmTeasable_SosDonationCertificateImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationFormImpl', id: string, type: string }
        & CmTeasable_SosDonationFormImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationProductImpl', id: string, type: string }
        & CmTeasable_SosDonationProductImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationProgressImpl', id: string, type: string }
        & CmTeasable_SosDonationProgressImpl_Fragment
      ) | (
        { __typename?: 'SOSDonationToolImpl', id: string, type: string }
        & CmTeasable_SosDonationToolImpl_Fragment
      ) | (
        { __typename?: 'SOSEventImpl', id: string, type: string }
        & CmTeasable_SosEventImpl_Fragment
      ) | (
        { __typename?: 'SOSFilterTeaserImpl', id: string, type: string }
        & CmTeasable_SosFilterTeaserImpl_Fragment
      ) | (
        { __typename?: 'SOSInternalLinkImpl', id: string, type: string }
        & CmTeasable_SosInternalLinkImpl_Fragment
      ) | (
        { __typename?: 'SOSJobTeaserImpl', deepLink?: string | null, id: string, type: string }
        & CmTeasable_SosJobTeaserImpl_Fragment
      ) | (
        { __typename?: 'SOSLocationImpl', id: string, type: string }
        & CmTeasable_SosLocationImpl_Fragment
      ) | (
        { __typename?: 'SOSNewsImpl', id: string, type: string }
        & CmTeasable_SosNewsImpl_Fragment
      ) | (
        { __typename?: 'SOSNotificationImpl', id: string, type: string }
        & CmTeasable_SosNotificationImpl_Fragment
      ) | (
        { __typename?: 'SOSOfferImpl', id: string, type: string }
        & CmTeasable_SosOfferImpl_Fragment
      ) | (
        { __typename?: 'SOSOrderFormImpl', id: string, type: string }
        & CmTeasable_SosOrderFormImpl_Fragment
      ) | (
        { __typename?: 'SOSOrganisationImpl', id: string, type: string }
        & CmTeasable_SosOrganisationImpl_Fragment
      ) | (
        { __typename?: 'SOSOverlayImpl', id: string, type: string }
        & CmTeasable_SosOverlayImpl_Fragment
      ) | (
        { __typename?: 'SOSPressreleaseImpl', id: string, type: string }
        & CmTeasable_SosPressreleaseImpl_Fragment
      ) | (
        { __typename?: 'SOSPublicationImpl', id: string, type: string }
        & CmTeasable_SosPublicationImpl_Fragment
      ) | (
        { __typename?: 'SOSRedirectPageImpl', id: string, type: string }
        & CmTeasable_SosRedirectPageImpl_Fragment
      ) | (
        { __typename?: 'SOSSpecialTopicCategoryImpl', id: string, type: string }
        & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
      ) | (
        { __typename?: 'SOSSpecialTopicImpl', id: string, type: string }
        & CmTeasable_SosSpecialTopicImpl_Fragment
      ) | (
        { __typename?: 'SOSTeaserImpl', id: string, type: string }
        & CmTeasable_SosTeaserImpl_Fragment
      ) | (
        { __typename?: 'SOSTextfragmentImpl', id: string, type: string }
        & CmTeasable_SosTextfragmentImpl_Fragment
      ) | (
        { __typename?: 'SOSTooltipImpl', id: string, type: string }
        & CmTeasable_SosTooltipImpl_Fragment
      ) | (
        { __typename?: 'SOSWimmelbildImpl', id: string, type: string }
        & CmTeasable_SosWimmelbildImpl_Fragment
      ) | (
        { __typename?: 'ViewTypeHeroCollection', id: string, type: string }
        & CmTeasable_ViewTypeHeroCollection_Fragment
      ) | null> | null } | null } | null };


export const GetSearchHitListDocument = gql`
    query GetSearchHitList($search: String!, $offset: Int, $limit: Int, $siteId: String, $docTypes: [String]) {
  content {
    search(
      query: $search
      offset: $offset
      limit: $limit
      docTypes: $docTypes
      siteId: $siteId
      includeSubTypes: false
    ) {
      numFound
      result {
        id
        type
        ...CMTeasable
        ... on SOSJobTeaser {
          deepLink
        }
      }
    }
  }
}
    ${CmTeasableFragmentDoc}`;

/**
 * __useGetSearchHitListQuery__
 *
 * To run a query within a React component, call `useGetSearchHitListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchHitListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchHitListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      siteId: // value for 'siteId'
 *      docTypes: // value for 'docTypes'
 *   },
 * });
 */
export function useGetSearchHitListQuery(baseOptions: Apollo.QueryHookOptions<GetSearchHitListQuery, GetSearchHitListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchHitListQuery, GetSearchHitListQueryVariables>(GetSearchHitListDocument, options);
      }
export function useGetSearchHitListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchHitListQuery, GetSearchHitListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchHitListQuery, GetSearchHitListQueryVariables>(GetSearchHitListDocument, options);
        }
export type GetSearchHitListQueryHookResult = ReturnType<typeof useGetSearchHitListQuery>;
export type GetSearchHitListLazyQueryHookResult = ReturnType<typeof useGetSearchHitListLazyQuery>;
export type GetSearchHitListQueryResult = Apollo.QueryResult<GetSearchHitListQuery, GetSearchHitListQueryVariables>;